import { forwardRef, createContext, Children } from 'react';

import * as XLSX from 'xlsx';


import { 
  TextField, Typography, CircularProgress, InputBase, TableCell, TableRow, TableSortLabel, 
  MenuItem, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, SvgIcon 
} from '@mui/material';
import { tableCellClasses } from '@mui/material/TableCell';
import { tableSortLabelClasses } from '@mui/material/TableSortLabel';
import { Search } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

import { withFormsy, } from 'formsy-react';

import _ from 'underscore';

const env = "0";
// Detecta se estamos na versão compilada (Produção)
const isProductionBuild = process.env.NODE_ENV === 'production';

// Le .env e prepara as tabelas internas com parametros do cliente
const raw = process.env.REACT_APP_INC;     // string do .env
const tuplas = JSON.parse(raw);            // vira array de arrays
const backTable = tuplas.map(t => ({
  incFLAG:  t[0],
  incNAME:  t[1],
  domNAME:  t[2],
  backACT:  t[3],
  backPORT: t[4],
  publicAPI: t[5] || ""
}));

export const labels = {
    0: {
      incFLAG:  backTable[0].incFLAG,
      baseURL:  (isProductionBuild && backTable[0].publicAPI)
        ? backTable[0].publicAPI 
        : (process.env.REACT_APP_baseURL + backTable[0].backACT + ":" + backTable[0].backPORT + "001/"),
      backACT:  backTable[0].backACT,
      backPORT: backTable[0].backPORT,
      incNAME:  backTable[0].incNAME,
      domNAME:  backTable[0].domNAME,
      navIMG:   "/static/" + backTable[0].domNAME + ".png",
      coverIMG: "/static/" + backTable[0].domNAME + ".webp",
      businessLabel: 'Empresa',
      divisionLabel: 'Departamento',
      objectLabel:   'Documentos',
      objectIDLabel: 'Identificação do documento',
      ongoingLabel:  'Em processamento',
      businessNotFound: 'Nenhuma empresa',
      divisionNotFound: 'Nenhum departamento',
      groupLabel:       'Filial-Grupo'
  },
      1: {
      incFLAG:  backTable[1].incFLAG,
      baseURL:  (isProductionBuild && backTable[1].publicAPI)
        ? backTable[0].publicAPI 
        : (process.env.REACT_APP_baseURL + backTable[1].backACT + ":" + backTable[1].backPORT + "001/"),
      backACT:  backTable[1].backACT,
      backPORT: backTable[1].backPORT,
      incNAME:  backTable[1].incNAME,
      domNAME:  backTable[1].domNAME,
      navIMG:   "/static/" + backTable[1].domNAME + ".png",
      coverIMG: "/static/" + backTable[1].domNAME + ".webp",
      businessLabel: 'Empresa',
      divisionLabel: 'Departamento',
      objectLabel:   'Documentos',
      objectIDLabel: 'Identificação do documento',
      ongoingLabel:  'Em processamento',
      businessNotFound: 'Nenhuma empresa',
      divisionNotFound: 'Nenhum departamento',
      groupLabel:       'Filial-Grupo'
  },
      2: {
      incFLAG:  backTable[2].incFLAG,
      baseURL:  (isProductionBuild && backTable[1].publicAPI)
        ? backTable[0].publicAPI 
        : (process.env.REACT_APP_baseURL + backTable[1].backACT + ":" + backTable[1].backPORT + "001/"),
      backACT:  backTable[2].backACT,
      backPORT: backTable[2].backPORT,
      incNAME:  backTable[2].incNAME,
      domNAME:  backTable[2].domNAME,
      navIMG:   "/static/" + backTable[2].domNAME + ".png",
      coverIMG: "/static/" + backTable[2].domNAME + ".webp",
      businessLabel: 'Empresa',
      divisionLabel: 'Departamento',
      objectLabel:   'Documentos',
      objectIDLabel: 'Identificação do documento',
      ongoingLabel:  'Em processamento',
      businessNotFound: 'Nenhuma empresa',
      divisionNotFound: 'Nenhum departamento',
      groupLabel:       'Filial-Grupo'
  }
};

// Global C contém os principais parâmetros para a sessão do usuário
export const C = {
  ai2IMG:     process.env.REACT_APP_ai2IMG,
  appNAME:    process.env.REACT_APP_NAME,
  appVERSION: process.env.REACT_APP_VERSION,
  incFLAG:    labels[env].incFLAG,
  baseURL:    labels[env].baseURL,
  backACT:    labels[env].backACT,
  backPORT:   labels[env].backPORT,
  incNAME:    labels[env].incNAME,
  domNAME:    labels[env].domNAME,
  navIMG:     labels[env].navIMG,
  coverIMG:   labels[env].coverIMG,
  businessLabel: labels[env].businessLabel,
  divisionLabel: labels[env].divisionLabel,
  objectLabel:   labels[env].objectLabel,
  objectIDLabel: labels[env].objectIDLabel,
  ongoingLabel:  labels[env].ongoingLabel,
  businessNotFound: labels[env].businessNotFound,
  divisionNotFound: labels[env].divisionNotFound,
  groupLabel:       labels[env].groupLabel
};

// Extrai o domínio do e-mail do usuário que logou
function DomainNameExtract(email) {
  if (!email || !email.includes("@")) return null;
  const dominioCompleto = email.split("@")[1].toLowerCase();
  return dominioCompleto.split(".")[0];
}

// Prepara a variavel de ambiente C para o cliente logado
function selBackforEmail(email) {
  const dominio = DomainNameExtract(email);
  if (!dominio) { console.error("E-mail inválido:", email); return -1; }

  // Encontra índice na backTable pelo dominio
  const index = backTable.findIndex(entry =>
    entry.domNAME.toLowerCase() === dominio
  );

  if (index === -1) { console.warn("Domínio não localizado:", dominio); return -1; }

  // Verifica se existe labels[index]
  if (!labels.hasOwnProperty(index)) { console.error("Não existe configuração labels para o índice:", index); return -1; }

  // Copia toda a configuração correspondente para C
  Object.assign(C, labels[index]);
  return index;
}

const defaultClient = {};

const ClientContext = createContext({
  client: defaultClient,
  setClient: () => {}
});

// ==========================================
// MODAIS GENÉRICOS
// ==========================================

export function ConfirmDialog({ title, msg, reg, children, onDeleteAction, onCancel, onConfirm }) {
  return (
    <D className="col e aF pa">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent style={{ minWidth: '25vw', maxWidth: '450px' }}>
        {!!msg && (
          <>
            <DialogContentText>{msg}</DialogContentText>
            <D h="1rem" />
          </>
        )}
        {!!reg && (
          <>
            <DialogContentText align="center" variant="h6">{reg}</DialogContentText>
            <D h="1rem" />
          </>
        )}
        <>{children}</>
      </DialogContent>
      <DialogActions>
        {onDeleteAction && <Button variant="outlined" color="primary" onClick={onDeleteAction}>Excluir</Button> }
        <Button variant="outlined" color="primary" onClick={onCancel}>
          {typeof onConfirm === 'function' ? 'Cancelar' : 'Fechar'}
        </Button>
        {typeof onConfirm === 'function' && <Button variant="outlined" color="primary" onClick={onConfirm}>Confirmar</Button>}
      </DialogActions>
    </D>
  );
}

export function MessageDialog({ title, msg, reg, children, onOk }) {
  return (
    <D className="col e aF pa">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent style={{ minWidth: '25vw' }}>
        {!!msg && (
          <>
            <DialogContentText>{msg}</DialogContentText>
            <D h="1rem" />
          </>
        )}
        {!!reg && (
          <>
            <DialogContentText align="center" variant="h6">{reg}</DialogContentText>
            <D h="1rem" />
          </>
        )}
        <>{children}</>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={onOk}>
          {typeof onOk === 'function' ? 'OK' : 'Fechar'}
        </Button>
      </DialogActions>
    </D>
  );
}

export const ConfirmDelete = ({ 
  title = "Confirmar exclusão",
  msg, 
  itemName, 
  onConfirm, 
  onCancel 
}) => {
  return (
    <>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{msg}</DialogContentText>
        <D h="1rem" />
        <DialogContentText align="center" variant="h6">
          {itemName}
        </DialogContentText>
        <D h="1rem" />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={onCancel}>
          Cancelar
        </Button>
        <Button variant="outlined" color="primary" onClick={onConfirm}>
          Confirmar
        </Button>
      </DialogActions>
    </>
  );
};

// ==========================================
// COMPONENTES DE TABELA CUSTOMIZADOS
// ==========================================

export const TCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#424242',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    whiteSpace: 'nowrap',
    wordWrap: 'normal'
  },
}));

export const TSortLabel = styled(TableSortLabel)(({ theme }) => ({
   [`&.${tableSortLabelClasses.root}`]: {
       color: theme.palette.common.white,
       "& $icon": {
            color: theme.palette.common.white
       },
       "&:hover": {
         color: theme.palette.common.white,
         '&& $icon': { color: theme.palette.common.white },
       },
       '&$active': {
         color: theme.palette.common.white,
         '&& $icon': { color: theme.palette.common.white },
       }
   },
   [`&.${tableSortLabelClasses.active}`]: {},
   [`& .${tableSortLabelClasses.icon}`]: {
       color: theme.palette.common.white,
       '& path': { fill: '#eee' }
   }
}));

export const TRow = ({ children, ...rest }) => (
  <TableRow
    {...rest}
    sx={{
      '&:nth-of-type(odd)': {
        backgroundColor: theme => theme.palette.action.hover,
      },
      '&:last-child td, &:last-child th': {
        border: 0,
      },
    }}
  >
    {Children.toArray(children).filter(
      child => !(typeof child === 'string' && child.trim() === '')
    )}
  </TableRow>
);

// ==========================================
// INPUTS E FORMULÁRIOS
// ==========================================

export function SearchField({ style, value, onChange, id = "search-input", name = "search" }) {
  return (
    <D
      className="row e aS"
      style={{
        minWidth: '100px',
        maxWidth: '450px',
        padding: '3px 7px 2px 7px',
        borderRadius: '0.5rem',
        backgroundColor: '#eeeeee',
        '&:hover': { backgroundColor: '#e0e0e0', },
        ...style,
      }}>
      <Search />
      <D size="1rem" />
      <InputBase
        id={id}               // <-- Adicionado aqui
        name={name}           // <-- Adicionado aqui
        autoComplete="off"    // <-- Recomendado para não sobrepor o autocompletar do navegador na sua UI
        style={{ color: 'inherit', width: '100%' }}
        placeholder="Buscar ..."
        value={value}
        onChange={e => onChange(e.target.value)} 
      />
    </D>
  );
}

// Convertido de Classe para Arrow Function limpa
export const Input = ({ 
  errorMessage, 
  variant = 'outlined', 
  margin = 'normal', 
  value = '', 
  onChange, 
  ...rest 
}) => {
  return (
    <D className="col w aF">
      <TextField
        {...rest}
        variant={variant}
        margin={margin}
        onChange={e => onChange ? onChange(e.currentTarget.value) : null} 
        value={value} 
      />
      {!!errorMessage && (
        <>
          <D h="3px" />
          <D className="row w aC">
            <Typography variant="caption">{errorMessage}</Typography>
          </D>
          <D h="10px" />
        </>
      )}
    </D>
  );
};

export function CustomSelect({ 
  options, value, label, InputLabelProps, className, style, width, 
  placeholder, disabled, heightSize, margin, onChange 
}) {
  return (
    <TextField
      defaultValue={''}
      value={options.includes(value) ? value : ''} 
      label={label}
      type='text'
      InputLabelProps={InputLabelProps}
      className="Input"
      inputProps={{ className: className }}
      style={{ ...style, width: !!width ? width : '100%' }}
      placeholder={placeholder}
      disabled={!!disabled}
      variant="outlined"
      size={!!heightSize ? heightSize : 'medium'}
      color="primary"
      margin={!!margin ? margin : 'normal'}
      select
      onChange={e => onChange(e.target.value)}>
      {typeof options === 'object' && options.length > 0 &&
        options ? options.map(o => {
          if (typeof o === 'object') {
            const [k, v] = Object.entries(o)[0];
            return <MenuItem key={k} value={k}>{v}</MenuItem>;
          } else {
            return <MenuItem key={o} value={o}>{o}</MenuItem>;
          }
        }) : <MenuItem></MenuItem>
      }
    </TextField>
  );
}

// ==========================================
// ESTRUTURA E WRAPPERS DA INTERFACE
// ==========================================

export function CenterContent({ 
  background, onClick, onChange, onMouseDown, id, className, 
  style, p, size, children 
}) {
  return (
    <D e className={'row aF ' + (!!background ? background : '')}>
      <D e className="hide-xlg" />
      <D e />
      <div  
        onClick={onClick} 
        onChange={onChange} 
        onMouseDown={onMouseDown} 
        id={id} 
        className={className} 
        style={{ ...style, ...{ flex: !!p ? p : 1, maxWidth: size } }}>
        {children}
      </div>
      <D e />
      <D e className="hide-xlg" />
    </D>
  );
}

export function Loading({ style }) {
  return (
    <D className="row e aC" style={style}>
      <CircularProgress />
    </D>
  );
}

// O componente D modernizado e fundido (Substitui as antigas classes D e o Div)
export const D = forwardRef((props, ref) => {
  const {
    onClick, onChange, onMouseDown, onMouseMove, onMouseUp, id, hide, row, col, e, w, cover, side, 
    className, p, h, size, img, style, imc, children, title, ...rest
  } = props;
  
  const computedClassName = [
    hide ? 'hide' : '',
    row ? 'row' : '',
    col ? 'col' : '',
    e ? 'e' : '',
    w ? 'w' : '',
    cover ? 'coverImg' : '',
    side ? 'sideImg' : '',
    className || '',
  ]
    .filter(Boolean)
    .join(' ');

  const computedStyle = {
    ...(p ? { flex: p } : {}),
    ...(h ? { minHeight: h } : {}),
    ...(size ? { flexBasis: size, minWidth: size, maxWidth: size } : {}),
    ...(img ? { backgroundImage: `url("${img}")` } : {}),
    ...style,
  };

  return (
    <div
      ref={ref}
      title={title}
      onClick={onClick}
      onChange={onChange}
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      id={id}
      className={computedClassName}
      style={computedStyle}
      {...rest}
    >
      {imc && <img alt="" src="/static/img/zero.png" className="icn-xmc" />}
      {children}
    </div>
  );
});
D.displayName = 'D';

// ==========================================
// ÍCONES CUSTOMIZADOS
// ==========================================

export function ApostileIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 100 100">
      <rect x="20" y="10" width="70" height="80" rx="4" fill="white" stroke="black" strokeWidth="4" />
      <path d="M10 20h20 M10 35h20 M10 50h20 M10 65h20 M10 80h20" stroke="black" strokeWidth="6" strokeLinecap="round" />
      <text x="55" y="28" fontSize="10" fontWeight="bold" textAnchor="middle" fill="black" fontFamily="sans-serif">
        RELATÓRIO
      </text>
      <rect x="35" y="45" width="8" height="15" fill="none" stroke="black" strokeWidth="2" />
      <rect x="50" y="35" width="8" height="25" fill="none" stroke="black" strokeWidth="2" />
      <rect x="65" y="50" width="8" height="10" fill="none" stroke="black" strokeWidth="2" />
      <path d="M35 72h40 M35 82h25" stroke="black" strokeWidth="3" strokeLinecap="round" />
    </SvgIcon>
  );
}

// ==========================================
// UTILITÁRIOS (FUNÇÕES)
// ==========================================

// PARA EXCEL
export const generateExcelFileName = (title) => {
    const safeTitle = (title || 'Tabela')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9]+/g, '_')
      .toLowerCase();

    const date = new Date()
      .toLocaleString('sv-SE')
      .replace(' ', '_')
      .replace(/:/g, '-');

      return `${safeTitle}_${date}.xlsx`;
};

/**
 * Função genérica para exportar planilhas padronizadas no sistema.
 * 
 * @param {string} params.title - Título que vai na Linha 1
 * @param {string} params.filtersText - Texto dos filtros que vai na Linha 2
 * @param {Array<Object>} params.headers - Array com os nomes das colunas (Linha 4) e larguras { header, width }
 * @param {Array<Array<any>>} params.data - Matriz com os dados (Linhas 5+)
 * @param {string} params.fileNamePrefix - Prefixo do nome do arquivo (ex: 'Mediateca')
 * @param {Function} [params.customFormatting] - (Opcional) Função para aplicar formatações específicas na worksheet
 */
export const exportStandardExcel = ({
  title,
  filtersText,
  columns, // Array unificado de objetos { header, width }
  data,
  fileNamePrefix,
  customFormatting
}) => {
  // Separa os cabeçalhos e as larguras
  const headers = columns.map(col => col.header);
  const columnWidths = columns.map(col => ({ wch: col.width }));

  // Monta a estrutura da planilha
  const sheetData = [
    [title],
    filtersText ? [filtersText] : [],
    [], // linha separadora
    headers,
    ...data
  ];

  // Cria a Worksheet
  const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

  // Aplica o tamanho das colunas extraídas
  worksheet['!cols'] = columnWidths;

  // Aplica formatações customizadas, se houver
  if (customFormatting && typeof customFormatting === 'function') {
    customFormatting(worksheet, data);
  }

  // Gera o arquivo e faz o download
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Documentos');
  XLSX.writeFile(workbook, generateExcelFileName(fileNamePrefix));
};


// --------------
// GENERICAS
// --------------

export const obj2form = d => {
  let l = new FormData();
  Object.entries(d).forEach(e => {
    const [k, v] = e;
    l.append(k, v);
  });
  return l;
};

const toHex = c => "#" + ((c[0] << 16) | (c[1] << 8) | c[2]).toString(16);

const toRgb = hex => {
    let r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return r ? [parseInt(r[1], 16), parseInt(r[2], 16), parseInt(r[3], 16)] : [];
};

const interpolateColor = (c1, c2, factor) => {
  var result = c1.slice();
  for (var i = 0; i < 3; i++) {
    result[i] = Math.round(result[i] + factor * (c2[i] - c1[i]));
  }
  return result;
};

export const getColors = (l, color1, color2) => {
  let stepFactor = 1 / (l - 1), inter = [];
  color1 = toRgb(color1);
  color2 = toRgb(color2);
  for (var i = 0; i < l; i++) {
    inter.push(toHex(interpolateColor(color1, color2, stepFactor * i)));
  }
  return inter;
};

export const getColorsByClass = (l) => {
    let myPalette = [];
    let colors = [
      toHex([31,119,180]), toHex([255,127,14]), toHex([44,160,44]), toHex([214,39,40]), 
      toHex([148,103,189]), toHex([140,86,75]), toHex([227,119,194]), toHex([127,127,127]), 
      toHex([188,189,34]), toHex([23,190,207]), toHex([177,89,40])
    ];
   for (var i = 0; i < l; i++) {
     myPalette.push(colors[i % colors.length]);
   }
   return myPalette;
};

export const checker = (ss, sf) => !sf ? true : !!_.compact(sf.split(' ')).every(e => ss.includes(e));

export const openLink = t => window.open(t, '_blank');

// ==========================================
// WRAPPERS DE FORMSY
// ==========================================

export const TextFieldFormsy = (props) => <FormsyInput {...props} _userProps={props} />;

// 2. Ajustamos o FormsyInput apenas para filtrar o _userProps
const FormsyInput = withFormsy(({ errorMessage, value, setValue, _userProps }) => {
  
  // O "Filtro": Tirar de _userProps apenas as regras do Formsy
  const {
    validations,
    validationErrors,
    validationError,
    validate,
    validateOnChange, 
    ...safeProps // O que sobra aqui é o label, type, InputProps, etc.
  } = _userProps;

  return (
    <Input 
      {...safeProps} // Usamos o objeto limpo em vez de jogar o _userProps inteiro
      value={value || ''} 
      errorMessage={errorMessage} 
      onChange={v => { 
        setValue(v); 
        if (_userProps.onChange) _userProps.onChange(v); 
      }} 
    />
  );
});
